//
//
//
//
//
//
//
//
//
//
//

import HouseItem from '@/components/business/house_item'
import BottomTip from '@/components/views/bottom_tip'
export default {
    components: {
        HouseItem
    },
    props: {
        items: Array,
        no_more: Boolean,
        loading: Boolean
    }
}
